<div class="air-details-container">

  <div *ngIf="!isShowMainBlock">
  <div class="section-sub-title"><b> LDAR Fugitive Emission Report - Build Search </b> </div>

    <div class="partioned-table">
      <div class="row">
        <div class="cell label label-text">Divison
        </div>
        <div class="cell value">
          <p-dropdown [options]="division" [(ngModel)]="filters.division" optionLabel="name" optionValue="value"
            placeholder="ALL" class="dropdown" class="custom-dropdown"
            panelStyleClass="custom-dropdown-panel"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Section
        </div>
        <div class="cell value">
          <p-dropdown [options]="sections" [(ngModel)]="filters.section" optionLabel="name" optionValue="value"
            placeholder="ALL" class="dropdown" class="custom-dropdown"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Plant
        </div>
        <div class="cell value">
          <p-dropdown [options]="plant" [(ngModel)]="filters.plant" optionLabel="name" optionValue="value"
            placeholder="ALL" class="dropdown" class="custom-dropdown"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Cost Center
        </div>
        <div class="cell value AreaBlue p-1-0 m-left">
          <input [(ngModel)]="filters.cost" name="cost center" type="text" id="contentContent_txtBlueTag"
            class="inputArea">
        </div>
      </div>

      <div class="row">
        <div class="cell label label-text">Maximo Work Order Number
        </div>
        <div class="cell value AreaBlue p-1-0 m-left">
          <input [(ngModel)]="filters.wo" name="maximo order" type="text" id="contentContent_txtBlueTag"
            class="inputArea">
        </div>
      </div>
    </div>
    <div class="button-row">
      <button (click)="runReport()">Run Report</button>
    </div>
  </div>

  <div *ngIf="isShowMainBlock">
    <!--  -->

    <div class="table-chart-container mt-10">
      <div class="display-flex">
  <div class="section-sub-title"><b> LDAR Fugitive Emission Report - Build Search </b> </div>

        <p class="m-0" style="font-size: small;">
          Division: <b>{{filters.division}}</b> 
          Section: <b>{{filters.plant}}</b> 
          Plant: <b>{{filters.plant}}</b> 
          Cost Center: <b>{{filters.cost}}</b> 
          MX WO #: <b>{{filters.wo}}</b>
        </p>
        <div class="exportToExcel excel-btn">
          <div class="actions">
            <button pButton type="button" label="Export To Excel" class="btn-primary" (click)="exportToExcel()">
              Export To Excel
            </button>
          </div>
        </div>
      </div>

      <p-table [value]="reportData" [paginator]="true" [rows]="10" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Data Entry Date</th>
            <th>Op. User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. Comments</th>
            <th>Insp. User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>TLR Surveillance</th>
            <th>Eng. User ID</th>
            <th>TLR Type</th>
            <th>Cost Center</th>
            <th>Maximo WO Number</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr let data of reportData>
            <td><a routerLink="/details-section/{{data.TagNumber}}">
                {{ data.TagNumber }}</a></td>
            <td>{{data.DEDateEntered | date:'MM/dd/yyyy'}}</td>
            <td>{{data.Operator_CAI}}</td>
            <td class="left-align">{{data.DivisionName}}</td>
            <td class="left-align">{{data.SectionName}}</td>
            <td class="left-align">{{data.PlantName}}</td>
            <td class="left-align">{{data.Rule1173}}</td>
            <td class="left-align">{{data.OperatorComments}}</td>
            <td>{{data.InspectionCAI}}</td>
            <td>{{data.ServiceClass}}</td>
            <td>{{data.OACAI}}</td>
            <td>
              <span class="{{commonService.getDateColorClass(data.PermanentRepairDate)}}"> {{ data.PermanentRepairDate | date: 'MM/dd/yyyy' }}</span>
            </td>
            <td>{{data.TLRSurveillance}}</td>
            <td>{{data.EngineeringCAI}}</td>
            <td>{{data.TLRType}}</td>
            <td>{{data.CostCenter}}</td>
            <td>{{data.MaximoWorkOrderNumber}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>